import React from 'react';
import '../Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="premium-footer">
      <div className="footer-wave">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 100" preserveAspectRatio="none">
          <path fill="#0a2540" fillOpacity="1" d="M0,32L60,42.7C120,53,240,75,360,74.7C480,75,600,53,720,42.7C840,32,960,32,1080,37.3C1200,43,1320,53,1380,58.7L1440,64L1440,100L1380,100C1320,100,1200,100,1080,100C960,100,840,100,720,100C600,100,480,100,360,100C240,100,120,100,60,100L0,100Z"></path>
        </svg>
      </div>
      <div className="footer-container">
        <div className="copyright-section">
          <div className="copyright-info">
            <div className="company-logo">
              <span className="logo-text">Job Tracker</span>
            </div>
            <p className="copyright-text">
              &copy; {currentYear} <span>SCT</span>. All rights reserved.
            </p>
          </div>
          {/* <div className="footer-links-wrapper">
            <ul className="footer-links">
              <li><a href="A">Privacy Policy</a></li>
              <li><a href="B">Terms of Service</a></li>
              <li><a href="C">Cookie Policy</a></li>
            </ul>
          </div> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;